<section class="operator-bridge-section">
  <div class="container">
    <div class="operator-bridge">
      <div class="operator-copy">
        <p class="operator-bridge-context">MemberTrace works for single organizations and teams supporting many.</p>
        <p class="eyebrow">For teams managing multiple member organizations</p>
        <h2>Standardize how you run the organizations you support</h2>
        <p class="operator-description">
          MemberTrace helps teams manage member data, events, dues, communications, and reporting across the organizations they support—without rebuilding workflows in spreadsheets and disconnected tools.
        </p>
      </div>

      <div class="operator-actions">
        <div class="operator-signal" *ngFor="let signal of operatorSignals">
          <mat-icon>{{ signal.icon }}</mat-icon>
          <span>{{ signal.label }}</span>
        </div>
        <div class="operator-buttons">
          <button mat-flat-button color="primary" routerLink="/for-operators">See operator use case</button>
          <button mat-stroked-button color="primary" routerLink="/contact" [queryParams]="{ inquiryType: 'operator' }">Book a walkthrough</button>
        </div>
      </div>
    </div>
  </div>
</section>
